<template>
  <dl class="card">
    <h3 class="icon-heading tiny">
      <span class="icon"><svg width="28px" height="28px" viewBox="0 0 28 28"><use
        xlink:href="/static/sprites.svg#glyph-medium-user"></use></svg></span>
      <span class="icon-heading-title">
        <span class="title">Kjøper</span>
        <span class="subtitle" style="font-size:0.78rem;" v-if="mottaker">{{mottaker.Kundenr}}</span>
        <span class="subtitle" style="font-size:0.78rem;" v-if="!objekt.kontrakt.Registrertsignert">Objektet kan ikke faktureres da kontrakten ikke er signert av selger.</span>
        <span class="subtitle" style="font-size:0.78rem;" v-else-if="!mottaker">Det finnes ingen kjøper enda...</span>
      </span>
    </h3>

    <dl v-if="mottaker">
      <dt>Navn</dt>
      <dd v-if="mottaker.Bedrift"><a :href="'/kunde/' + mottaker.Kundenr">{{mottaker.FirmaNavn || mottaker.full_name}}</a></dd>
      <dd v-else><a :href="'/kunde/' + mottaker.Kundenr">{{mottaker.full_name}}</a></dd>

      <dt>E-post</dt>
      <dd v-if="mottaker.Email">
        <a :href="'mailto:' + mottaker.Email">{{mottaker.Email}}</a>
      </dd>
      <dd v-else>-</dd>

      <template v-if="mottaker.Tlfprivat">
        <dt>Telefon privat</dt>
        <dd>{{mottaker.Tlfprivat}}</dd>
      </template>

      <template v-if="mottaker.Tlfarbeid">
        <dt>Telefon arbeid</dt>
        <dd>{{mottaker.Tlfarbeid}}</dd>
      </template>

      <template v-if="mottaker.Mobil">
        <dt>Mobil</dt>
        <dd>{{mottaker.Mobil}}</dd>
      </template>

      <template v-if="sameAddress">
        <dt>Faktura- og leveringsadresse</dt>
        <dd v-if="adresseLevering">{{adresseLevering.full_address}}</dd>
        <dd v-else>-</dd>
      </template>
      <template v-else>
        <dt>Leveringsadresse</dt>
        <dd v-if="adresseLevering">{{adresseLevering.full_address}}</dd>
        <dd v-else>-</dd>

        <dt>Fakturaadresse</dt>
        <dd v-if="adresseFaktura">{{adresseFaktura.full_address}}</dd>
        <dd v-else>-</dd>
      </template>

      <dt>
        <a v-if="isPresenceOwner" href="javascript:;" @click="openAddressModal" class="button secondary initiate-loading"><span
          class="button-title">Rediger adresse</span></a>
        <a v-else href="javascript:;" class="button primary initiate-loading disabled"><span class="button-title">Rediger adresse</span></a>

        <a v-if="isPresenceOwner && objekt.Fakturert != 'F'" href="javascript:;" @click="removeBuyer" class="button secondary initiate-loading"><span
          class="button-title">Fjern Kjøper</span></a>
        <a v-else-if="objekt.Fakturert != 'F'" href="javascript:;" class="button primary initiate-loading disabled"><span
          class="button-title">Fjern Kjøper</span></a>
      </dt>
      <dd></dd>
    </dl>
    <dl v-else-if="objekt.kontrakt.Registrertsignert">
      <br>
      <br>
      <TheAutoCompleteInput containerClassName="cell medium-12" v-model.trim="MottakerName"
        name="MottakerName" :placeholder="'Velg kjøper...'" :label="'Kjøper'"
        v-validate="'min:1'" :onInputCallback="onKundeSearchInput"
        :onSelectCallback="onKundeSearchSelected" :onResetCallback="onKundeSearchReset"
        :debounce="1250" :minquery="2"
        :disabled="!isPresenceOwner"
      >
        <div slot="item" slot-scope="props">
          <strong>{{props.item.Kundenr}}</strong>
          <span v-if="props.item.Bedrift">{{ props.item.FirmaNavn || props.item.full_name }}</span>
          <span v-else>{{ props.item.full_name }}</span>
        </div>
      </TheAutoCompleteInput>
      <div class="grid-x grid-padding-x">
        <div class="cell auto"></div>
        <div class="cell shrink">
          <template v-if="!isPresenceOwner">
            <a href="javascript:;" class="button primary disabled"><span class="button-title">Lagre</span></a>
          </template>
          <template v-else>
            <a href="javascript:;" v-if="Mottaker && !loadingKunde" @click="saveBuyer"
              class="button primary initiate-loading"><span class="button-title">Lagre</span></a>
            <a href="javascript:;" v-if="!Mottaker && !loadingKunde" class="button primary disabled"><span
              class="button-title">Lagre</span></a>
            <a href="javascript:;" v-if="loadingKunde" class="button primary loading"><span
              class="button-title">Lagrer</span> <span class="loader-spinner"></span></a>
          </template>
        </div>
      </div>
    </dl>
  </dl>
</template>

<script>
import bus from '@/plugins/event-bus'
import TheAutoCompleteInput from '../Inputs/TheAutoCompleteInput'
import KundeService from '@/services/KundeService'
import ObjektService from '@/services/ObjektService'

export default {
  name: 'KundeKontraktObjektTabKjoperMottaker',
  components: {
    TheAutoCompleteInput
  },
  props: {
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      mottaker: {},
      Mottaker: null,
      MottakerName: null,
      MottakerObject: {},
      loadingKunde: false,
      adresseFaktura: {},
      adresseLevering: {},
      presenceChannelName: null
    }
  },
  created () {
    bus.$off('objekt-mottaker-updated')

    // Set name for the WS channel
    this.presenceChannelName = 'presence-objekt-edit-' + this.objekt.Objektid

    this.mottaker = this.objekt.mottaker ? this._.cloneDeep(this.objekt.mottaker) : null

    this.setupAddresses()
  },
  mounted () {
    bus.$on('objekt-mottaker-updated', (data) => this.onMottakerAddressUpdated(data))
  },
  watch: {
    'objekt': {
      handler (newVal, oldVal) {
        if (newVal !== undefined) {
          this.mottaker = this.objekt.mottaker ? this._.cloneDeep(this.objekt.mottaker) : null

          if (!this.mottaker) {
            this.Mottaker = null
            this.MottakerName = null
            this.MottakerObject = {}
          } else {
            this.Mottaker = this.mottaker.Kundenr
            this.MottakerName = this.mottaker.full_name
            this.MottakerObject = this.mottaker
          }

          this.setupAddresses()
        }
      },
      deep: true
    }
  },
  computed: {
    sameAddress: function () {
      // Check if it is same address / for the checkbox
      if (this._.isEmpty(this.adresseLevering)) {
        return true
      }

      return this._.isEqual(this.adresseFaktura.full_address, this.adresseLevering.full_address)
    },
    isPresenceOwner: function () {
      return this.$store.getters['presence/isOwner'](this.presenceChannelName)
    }
  },
  methods: {
    setup: function () {
      this.Mottaker = this.kunde.Kundenr
      this.MottakerName = this.kunde.full_name
      this.MottakerObject = this.kunde
    },
    setupAddresses: function () {
      if (this.mottaker) {
        this.adresseFaktura = this._.find(this.mottaker.kundeadresse, [ 'Type', 'faktura' ]) || false
        this.adresseLevering = this._.find(this.mottaker.kundeadresse, [ 'Type', 'levering' ]) || false
      }
    },
    onMottakerAddressUpdated: function (data) {
      this.$helpers.showSuccessAlert('Kjøperadresse er lagret')

      // Make a copy of objekt and set new mottaker
      let item = this._.cloneDeep(this.objekt)
      item.mottaker = Object.assign({}, item.mottaker, data)

      // Also change mottaker in this file + reload the addresses
      this.mottaker = Object.assign({}, item.mottaker, data)
      this.setupAddresses()

      // Send event to root - to update objekt
      bus.$emit('mottaker-updated', item.mottaker)
      bus.$emit('kunde-kontrakt-objekt-updated', item)
      // sessionStorage.showObjektTab = 'kjoper'
      // bus.$emit('objekt-modal-reload')
    },
    openAddressModal: function () {
      this.openModal(
        'kunde-adresse-modal',
        {
          kunde: this.mottaker,
          event: 'objekt-mottaker-updated'
        }
      )
    },
    onKundeSearchReset: function () {
      this.Mottaker = null
      this.MottakerName = null
      this.MottakerObject = {}
    },
    onKundeSearchInput: function (query) {
      return KundeService.search(query)
    },
    onKundeSearchSelected: function (item) {
      if (item) {
        this.Mottaker = item.Kundenr || null
        this.MottakerName = item.full_name || ''
      }
    },
    saveBuyer: function () {
      this.loadingKunde = true

      ObjektService.setMottakerObjekt(this.objekt.Objektid, this.Mottaker)
        .then((response) => {
          this.mottaker = response.data.kunde

          bus.$emit('mottaker-updated', response.data.kunde)
          bus.$emit('kunde-kontrakt-objekt-updated', response.data.objekt)
          // sessionStorage.showObjektTab = 'kjoper'
          // bus.$emit('objekt-modal-reload')
        })
        .catch((e) => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn mottaker')
          this.onKundeSearchReset()
        })
        .then(() => {
          this.loadingKunde = false
        })
    },
    removeBuyer: function () {
      let vm = this
      this.openConfirm(
        'Fjern kjøper',
        `Er du sikker på at du vil fjerne ${this.mottaker.full_name} som kjøper av dette objektet?`,
        'Ja',
        'Nei',
        function () {
          vm.cancelButtonText = ''
          vm.okButtonText = 'Laster'
          ObjektService.setMottakerObjekt(vm.objekt.Objektid, 0)
            .then(function (response) {
              vm.mottaker = null
              vm.onKundeSearchReset()

              bus.$emit('kunde-kontrakt-objekt-updated', response.data.objekt)
              bus.$emit('mottaker-updated', vm.mottaker)
              // sessionStorage.showObjektTab = 'kjoper'
              // bus.$emit('objekt-modal-reload')
              vm.closeModal()
            })
            .catch((e) => {
              vm.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn mottaker')
              vm.onKundeSearchReset()
            })
            .then(() => {
              vm.loadingKunde = false
            })
        },
        function () {
          vm.closeModal()
        }
      )
    }
  }
}
</script>
<style scoped>
  dd a {
    color:blue;
    text-decoration: underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabKjoperMottaker.vue